import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import cx from "classnames";
import { Grid } from "semantic-ui-react";
import { bindActionCreators } from "redux";
import { resetStore } from "../../actions/resetStoreActions";
import {
  Header,
  ContactUs as ContactUsComponent
} from "../../components/common";
import styles from "./styles.less";

class ContactUs extends React.Component {
  renderHeader = title => {
    const { isRtl, isMobileView } = this.props;
    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <Header
            noSidePadding={true}
            isRtl={isRtl}
            text={title}
            isMobileView={isMobileView}
            lightBottomPadding={true}
          />
        </Grid.Column>
      </Grid.Row>
    );
  };

  renderContacUsForm = () => {
    const {
      submitContactUsForm,
      selectedOption,
      titles,
      checkinDate,
      checkoutDate,
      currentPaxCombination,
      contactUsSubmitingStatus,
      isMobileView,
      lang,
      hotelData
    } = this.props;
    const needToShowForm = contactUsSubmitingStatus
      ? !contactUsSubmitingStatus.succeed == true
      : true;

    return (
      <ContactUsComponent
        lang={lang}
        onSubmit={submitContactUsForm}
        checkinDate={checkinDate}
        checkoutDate={checkoutDate}
        selectedOption={selectedOption}
        pax={currentPaxCombination}
      >
        {({ onSubmit }) =>
          needToShowForm ? (
            <React.Fragment>
              <div className={styles.contactUsHeader}>
                <ContactUsComponent.OptionsToContact
                  className={styles.optionToContant}
                  phoneNumber={hotelData.HotelPhone}
                  isMobileView={isMobileView}
                  titleCall={titles.Call}
                />
              </div>
              <ContactUsComponent.OrStrip orTitle={titles.Or} />
              <div className={cx(styles.headerText, styles.sendYourRequest)}>
                {titles.SendYourRequestAndWeWillReturn}
              </div>
              <ContactUsComponent.ContactUsForm
                onSubmit={onSubmit}
                titles={titles}
                submitingStatus={contactUsSubmitingStatus}
                isMobileView={isMobileView}
                requestType={titles.ContactUsRequest}
              />
            </React.Fragment>
          ) : (
            <ContactUsComponent.ContactUsConfirmation titles={titles} />
          )
        }
      </ContactUsComponent>
    );
  };

  render() {
    const { titles, isMobileView } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column className={cx(styles.viewPort, styles.relaxed)}>
            {this.renderHeader(titles.ContactUs)}
            <div
              className={cx(styles.contactUsWrapper, {
                [styles.mobileView]: isMobileView
              })}
            >
              {this.renderContacUsForm()}
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

ContactUs.propTypes = {
  titles: PropTypes.object,
  isMobileView: PropTypes.bool,
  currentPaxCombination: PropTypes.object,
  isRtl: PropTypes.bool,
  contactUsSubmitingStatus: PropTypes.object,
  submitContactUsForm: PropTypes.func,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string,
  selectedOption: PropTypes.object,
  lang: PropTypes.string,
  hotelData: PropTypes.object
};

const mapStateToProps = store => {
  const state = {
    titles: store.titles,
    isMobileView: store.isMobileView,
    currentPaxCombination: store.currentPaxCombination,
    isRtl: store.isRtl,
    contactUsSubmitingStatus: store.contactUsSubmitingStatus,
    checkinDate: store.checkinDate,
    checkoutDate: store.checkoutDate,
    selectedOption: store.selectedOption,
    lang: store.lang,
    hotelData: store.hotelData
  };
  return state;
};

function mapDispatchToProps(dispatch) {
  const combinedActions = {
    resetStore
  };
  return {
    actions: bindActionCreators(combinedActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContactUs);



// WEBPACK FOOTER //
// ./src/containers/ContactUs/ContactUs.js